"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheControlMaxValueForMaxAgeInSecs = void 0;
const names_and_enums_1 = require("../names-and-enums");
/**
 * 1 year in seconds.
 * First used for setting a long-lived Cache-Control max-age value.
 */
function cacheControlMaxValueForMaxAgeInSecs() {
    return 365.25 * names_and_enums_1.DayMs / 1000;
}
exports.cacheControlMaxValueForMaxAgeInSecs = cacheControlMaxValueForMaxAgeInSecs;
//# sourceMappingURL=browser-cache.js.map